import { Fragment } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <Fragment>
      <div class="container-fluid">
        <footer class="d-flex flex-wrap justify-content-between align-items-center pt-5 mt-6 border-top ">
          <p class="col-md-4 mb-0 text-muted ">&copy; 2022 Nepayouthclub, Inc</p>

          <ul class="nav col-md-4 justify-content-end ">
            <li class="nav-item">
              <Link class="nav-link text-black" to="/" aria-current="page">
                Home
              </Link>
            </li>
            <li class="nav-item">
              <Link className="nav-link text-black" to="/news">
                News
              </Link>
            </li>
            <li class="nav-item">
              <Link className="nav-link text-black"  to="/about">
                About
              </Link>
            </li>
            <li class="nav-item">
              <Link className="nav-link text-black" to="/contact">
                Contact us
              </Link>
            </li>
            <li class="nav-item">
              <Link className="nav-link text-black" to="/FAQ">
                FAQs
              </Link>
            </li>
          </ul>
        </footer>
      </div>
    </Fragment>
  );
};

export default Footer;
